import i18n from "i18next";
import LanguageDetector  from "i18next-browser-languagedetector";
import { initReactI18next } from 'react-i18next';

// Import your translation files
import translationEN from './locales/en.json';
import translationFR from './locales/ar.json';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        translation: translationEN,
      },
      fr: {
        translation: translationFR,
      },
    },
    fallbackLng: process.env.PUBLIC_AVAILABLE_LANGUAGES, // default language
    debug: true, // Enable logging for debugging
    interpolation: {
      escapeValue: false, // React already escapes by default
    },
  });